export const firstTimeDeposit = 'FTD';
